import { Link } from "@tanstack/react-router";
import { ArrowRight, Check } from "lucide-react";

type Props = {
  slug: string;
  name: string;
  short: string;
  benefits: readonly string[];
  image: string;
};

export function ServiceCard({ slug, name, short, benefits, image }: Props) {
  return (
    <article className="group relative flex flex-col overflow-hidden rounded-sm border border-border bg-charcoal transition-all hover:border-copper">
      <div className="aspect-[4/3] overflow-hidden">
        <img
          src={image}
          alt={name}
          loading="lazy"
          className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
        />
      </div>
      <div className="flex flex-1 flex-col p-6">
        <h3 className="text-xl text-silver-light">{name}</h3>
        <p className="mt-2 text-sm text-silver">{short}</p>
        <ul className="mt-4 space-y-1.5 text-sm text-silver">
          {benefits.map((b) => (
            <li key={b} className="flex items-start gap-2">
              <Check className="h-4 w-4 mt-0.5 text-copper shrink-0" /> {b}
            </li>
          ))}
        </ul>
        <Link
          to={`/services/${slug}` as string}
          className="mt-6 inline-flex items-center gap-2 text-sm font-semibold uppercase tracking-wider text-copper hover:gap-3 transition-all"
          aria-label={`Explore ${name}`}
        >
          Explore {name} <ArrowRight className="h-4 w-4" />
        </Link>
      </div>
    </article>
  );
}
